import React from 'react';
import styled from 'styled-components';
import { Flex, Button } from 'rebass';
import { FiPlus, FiX } from 'react-icons/fi';

/**
 * Presentational building blocks for a Settings > Integrations tile.
 *
 * Extracted from SettingsIntegrationsPage so the manifest-driven incentive
 * provider tiles render identically to the hand-written ones next to them — the
 * two lists sit in the same page and must not drift apart visually.
 */

export const IntegrationItem = styled(Flex)`
    flex-direction: column;
    width: 800px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding: 32px;
    margin-bottom: 16px !important;
`;

export const IntegrationHeader = styled(Flex)`
    flex-direction: row;
    img {
        width: 32px;
        margin-right: 16px;
        object-fit: scale-down;
        object-position: left top;
    }
    a {
        text-decoration: underline;
    }
`;

export const IntegrationActionButtons = styled(Flex)`
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-end;
    padding-left: 16px;
    width: 220px;
    button {
        width: fit-content;
    }
`;

export const IntegrationDivider = styled.hr`
    margin-top: 24px;
    margin-bottom: 24px;
    border-color: #d4d9dd;
`;

export const IntegrationStatus = styled(Flex)`
    justify-content: space-between;
    align-items: center;
`;

/**
 * @param {Object} props
 * @param {() => void} props.onClick Disconnect handler
 * @param {boolean?} props.disabled Blocks a second click while one is in flight
 */
export const DisconnectButton = ({ onClick, disabled }) => (
    <Button variant="danger" onClick={onClick} disabled={disabled}>
        <FiX style={{ strokeWidth: '2px', fontSize: '15px', margin: '4px 4px 0 0' }} /> Disconnect
    </Button>
);

/**
 * @param {Object} props
 * @param {() => void} props.onClick Connect handler
 */
export const ConnectButton = ({ onClick }) => (
    <Button variant="secondary-gray" onClick={onClick}>
        <FiPlus style={{ strokeWidth: '2px' }} /> Connect
    </Button>
);
